import {generateSiteToken} from "@/app/utils/loan/loan-utils";

export type ErrorMode = 'throw' | 'notFound' | 'silent'

export interface HitProtectedBackendApiConfig {
    cache?: boolean
    tokenPrefix?: string | null
    method?: 'GET' | 'POST' | 'PUT' | 'DELETE' | 'PATCH'
    signal?: AbortSignal
}

export function hitProtectedBackendApi(
    url: string,
    config: HitProtectedBackendApiConfig = {},
    payload?: Record<string, any>
) {
    const {
        cache = false,
        tokenPrefix = null,
        method = 'GET',
        signal,
    } = config

    const headers: Record<string, string> = {
        "X-Site-Token": tokenPrefix ? generateSiteToken(tokenPrefix) : 'rm_website',
    }

    if (payload) {
        headers['Content-Type'] = 'application/json'
    }

    return fetch(url, {
        method,
        headers,
        cache: cache ? 'force-cache' : 'no-store',
        // Cross-site in prod (reassurez-moi.fr -> app.reassurez-moi.fr): 'include' forwards the
        // attribution cookies (rm_user_token, rm_utm_*…) for the Symfony UtmTracking -> Brevo
        // mapping; requires the matching nelmio_cors allow_credentials rule on /api/loan-comparator/.
        credentials: 'include',
        ...(signal && { signal }),
        ...(payload && { body: JSON.stringify(payload) })
    })
}
